<!--Cancel Policy 1 Modal-->
<div class="modal fade" style="background-color: rgba(0, 0, 0, 0.4);" id="cancelModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
  data-backdrop="static" data-keyboard="false" aria-hidden="true">
<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content cancel_ModalContent">
    <div class="modal-header">
      <h5 name="CancelPolicy" class="modal-title" id="CancelPolicyID">Cancel Policy - {{policyDetails?.policyNumber}}</h5>
      <button name="cancelclose" id="cancelcloseID" class="close" type="button" data-dismiss="modal" aria-label="Close" (click)="close()">
        <span name="cancelclosesym" id="cancelclosesymID" aria-hidden="true">×</span>
      </button>
    </div>
    <div *ngIf="!IsCancel" class="modal-body">
      <!-- <div class="row mb-2" [hidden]="!dao?.closedPopupModel?.isShowError">
        <div class="col-lg-12 text-center">
          <label name="errormsg" id="errormsgID" class="pop_label label_cls mt-2  text-red"> {{dao?.closedPopupModel?.errorMsg}} </label>
        </div>
      </div> -->
      <div class="row">
        <div class="col-md-6">
          <label name="cancelnameinsured" id="cancelnameinsuredID" class="pop_label label_cls mt-2">
            Name Insured:
          </label>
          <span name="cancelnameinsuredval" id="cancelnameinsuredvalID" class="ml-2">{{policyDetails?.nameInsured}}</span>
        </div>
        <div class="col-md-6">
          <label name="Cancelpolicyterm" id="CancelpolicytermID" class="pop_label label_cls mt-2">
            Policy Term:
          </label>
          <span name="Cancelpolicytermval" id="CancelpolicytermvalID" class="ml-2">{{policyDetails?.effectiveDate | date:'MM/dd/yyyy'}} - {{policyDetails?.expireDate | date:'MM/dd/yyyy'}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label name="canceltotalpremium" id="canceltotalpremiumID" class="pop_label label_cls mt-2">
            Total Premium:
          </label>
          <span name="canceltotalpremiumval" id="canceltotalpremiumvalID" class="ml-2">$ {{policyDetails?.summaryTotals?.brPremiumAmount}}</span>
        </div>
        <div class="col-md-6">
          <label name="Cancelbillplan" id="CancelbillplanID" class="pop_label label_cls mt-2">
            Bill Plan:
          </label>
          <span name="Cancelbillplanval" id="CancelbillplanvalID" class="ml-2">{{policyDetails?.paymentInfo?.paymentOption}} {{policyDetails?.paymentInfo?.paymentPlan?'-':''}} {{policyDetails?.paymentInfo?.paymentPlan}}</span>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <label name="canceljobaddress" id="canceljobaddressID" class="pop_label label_cls mt-2">
            Jobsite Address:
          </label>
          <span name="canceljobaddressval" id="canceljobaddressvalID" class="ml-2">{{policyDetails?.jobSiteAddress}}</span>
        </div>
        <div class="col-md-6">
          <label name="cancelstatus" id="cancelstatusID" class="pop_label label_cls mt-2">
            Status:
          </label>
          <span name="cancelstatusval" id="cancelstatusvalID" class="ml-2">{{policyDetails?.status}}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-12">
            <hr style="margin-top: 0.2rem;margin-bottom: 0.5rem;"/>
        </div>
      </div>

      <div class="row mb-2" [hidden]="cancelDetails?.cancelEffectiveDate?.hidden ==='true'">
        <div class="col-lg-5">
          <label name="canceleffectivedate" id="canceleffectivedateID" class="pop_label label_cls mt-2">
            Cancellation Effective Date :
          </label>
        </div>
        <div class="col-lg-6 calen_cls">
          <!-- <input name="canceleffectivedateval" id="canceleffectivedateID" type="date" value="2020-08-12" max="3000-12-31"
            [(ngModel)]="effectiveDate" min="1000-01-01" class="form-control"> -->
            <p-calendar class="cancelreason" (onSelect)="dateerror = false" [maxDate]="maxDate" [minDate]="minDate" selectOtherMonths="true" [(ngModel)]="effectiveDate" [showIcon]="true" placeholder="Select Effective Date"
            inputId="canceleffectivedateID"></p-calendar>
            <label name="dateerror" id="dateerror" *ngIf="dateerror" class="pop_label label_cls text-red">Cancellation Effective Date is required</label>
        </div>        
      </div>
      <div class="row mb-2" [hidden]="cancelDetails?.cancelReasonCd?.hidden ==='true'">
        <div class="col-lg-5">
          <label name="cancelReason" id="cancelReasonID" class="pop_label label_cls mt-2">
            Cancellation Reason :
          </label>
        </div>
        <div class="col-lg-6">
          <!-- <select name="cancelReasonval" id="cancelReasonvalID" class="form-control classic" [(ngModel)]="dao.closedPopupModel.cancelReasonCdModal">
            <option *ngFor="let cr of policyReasons" [value]="cr?.code">
              {{cr.label}}</option>
          </select> -->
          <p-dropdown name="cancelReasonval" id="cancelReasonvalID" optionLabel="label" optionValue="code" class="cancelreason padding_10"
            placeholder="Select Reason" [options]="policyReasons" (onChange)="changeReason()" [(ngModel)]="dao.closedPopupModel.cancelReasonCdModal">
          </p-dropdown>
          <label name="reasonerror" id="reasonerror" *ngIf="reasonerror" class="pop_label label_cls text-red">Cancellation Reason is required</label>
        </div>
      </div>
      <div class="row" *ngIf="policyDetails?.customizedCoverageOCP=='ACCEPT' || policyDetails?.customizedCoverageOCP=='DECLINE'" [hidden]="cancelDetails?.cancelEffectiveDate?.hidden ==='true'">
        <div class="col-lg-4 text-right">
          <label name="cancelcancelocp" id="cancelcancelocpID" class="pop_label label_cls mt-1 ">
            Do you need to cancel an OCP policy ? :
          </label>
        </div>
        <div class="col-lg-6">
          <div class="checkbox m-0">
            <input name="cancelcancelocpval" type='checkbox' id="cancelcancelocpvalID" [checked]="IsCancelOCP" [(ngModel)]="dao.closedPopupModel.cancelOCP"
            (change)="IsCancelOCP = !IsCancelOCP" />
            <label name="cancelocp_lbl" style="width: 0;padding:0" id="cancelcancelocplbl" for="cancelcancelocpvalID">
            &nbsp;
            </label>
            </div>
          <!-- <input type='checkbox' [checked]="IsCancelOCP" [(ngModel)]="dao.closedPopupModel.cancelOCP"
            (change)="IsCancelOCP = !IsCancelOCP" name='thing' id="thing" /> -->
        </div>
      </div>
      <div class="row mb-2" *ngIf="IsCancelOCP">
        <div class="col-lg-4 text-right">
          <label name="ocpPolicyNumber" id="ocpPolicyNumberID" class="pop_label label_cls mt-0">
            Please provide your OCP policy number:
          </label>
        </div>
        <div class="col-lg-6">
          <input name="ocpPolicyNumberVal" id="ocpPolicyNumberValID" placeholder="Enter OCP Policy Number" type="text" class="form-control" style="width:80%" [(ngModel)]="ocpNumber">
        </div>
      </div>
      <div class="row info_icon" *ngIf="IsCancelOCP">
        <i class="fa fa-info-circle" aria-hidden="true"></i>
      </div>
      <div *ngIf="IsCancelOCP" class="row alert alert-info alert-dismissible mb-0 ml-1 mr-1" style="position: none !important;">
        <div class="col-lg-12">
            <p style="font-size: 13px;margin-left:7px;margin-top: -5px;">We have sent the requested Cancellation to Berkley Aspire to process the cancellation of your OCP policy. 
              If you have questions regarding your OCP policy please contact Berkley Aspire at ocp&#64;berkleyaspire.com</p>
        </div>
      </div>
    </div>
    <div *ngIf="IsCancel" class="modal-body mt-0 mb-2">
      <div name="policycancelmsg" id="policycancelmsgID" class="policy_cancel mb-2">
        Policy {{dao?.policyNumber}} has been canceled
      </div>
      <div class="balance_due mb-2">
        <span name="balancedue" id="balancedueID" class="text-left mt-3 float-left">
          Balance Due :
        </span>
        <label name="balancedueval" id="balanceduevalID" class="balance_amt">{{dao?.closedPopupModel?.returnedPremium}}</label>
      </div>
    </div>
    <div class="row m-0 mr-lg-3">
      <div class="col-md-12 p-0">
        <div class="modal-footer" style="margin-top:0px;">
          <!-- <div class="col-lg-12 p-0">           
            <div class="col-lg-12 d-flex pl-0"  *ngIf="!IsCancel">
              <div class="checkbox m-0">
                <input name="cancelrequestval" type="checkbox" class="mousePointer" id="cancelrequestvalID" style="margin-left: 16px;height: 16px;width: 17px;" [(ngModel)]="acknowledge">
                <label name="cancelrequest" id="cancelrequestID" for="cancelrequestvalID" style="margin-left:14px !important;margin-top:-5px;pointer-events: none;" class="ml-3 small" >I Acknowledge that the Agent has received and has on 
                file the signed Cancellation Request form.</label> 
              </div> 
            </div>
          </div> -->
          <div *ngIf="!IsCancel" class="row mb-2" style="margin-right: -8px;">
            <!-- data-toggle="modal" data-target="#cancelModal" -->
            <input  id="policyNumberModalID" type="hidden" class="form-control" name="policyNumberModal" [value]="dao?.policyNumber"
              [(ngModel)]="dao.closedPopupModel.policyNumberModal">
            <button name="cancelPolicy" id="cancelPolicyID" [disabled]="dao.closedPopupModel.isShowError" style="margin-top:-13px" class="SubmitBtn" (click)="calculateChange()" type="button">Calculate Change</button>
          </div>
          <a name="cancelOk" id="cancelOkID" style="width: 50px !important" *ngIf="IsCancel" class="btn btn-primary ok_btn_cls" data-dismiss="modal" (click)="close()" href="#">OK</a>
        </div>
      </div>
    </div>
  </div>
</div>
    <p-dialog
        header="Error Notification" [(visible)]="showCancelPolicyLockPopup"
        [modal]="true" [closable]="true"
        [draggable]="false" [resizable]="false"
        [style]="{ width: '500px' }">

        <div class="popup-message">
            <span [innerHTML]="policyLockMessage"></span>
        </div>

        <div class="text-center mt-3">
            <button
                class="policyCloseBtn"
                (click)="closePolicyLockPopup()">
                OK
            </button>
        </div>

    </p-dialog>
  <p-dialog header="Cancellation" (onHide)="isConfirmCancel=false;"
        styleClass="PremiumPopUp dialo_popup" [(visible)]="isConfirmCancel" [modal]="true"
        [style]="{width: '50vw !important'}" [baseZIndex]="1000" [draggable]="false" [resizable]="false"
        [closable]="true">
        <div class="row mt-2">
            <div class="col-lg-12 form-inline p-0">
                <div class="col-lg-6 text-left">
                    <label style="float: left;" class="policyHeading">Return Premium:</label>
                    <label class="ml-2" style="float: left;">{{premiumAmount}}</label>
                </div>
                
            </div>
        </div>
        <div class="col-lg-12 mt-4 p-0">           
          <div class="col-lg-12 d-flex pl-0">
            <div class="checkbox m-0">
              <input name="cancelrequestval" type="checkbox" class="mousePointer" id="cancelrequestvalID" style="margin-left: 16px;height: 16px;width: 17px;" [(ngModel)]="acknowledge">
              <label name="cancelrequest" id="cancelrequestID" for="cancelrequestvalID" style="margin-left:14px !important;margin-top:-5px;pointer-events: none;" class="ml-3 small" >I Acknowledge that the Agent has received and has on 
              file the signed Cancellation Request form.</label> 
            </div> 
          </div>
        </div>
        <div class="row">
            <div class="col-lg-12 text-right">
                <button class="policyCloseBtn mr-2" (click)="isConfirmCancel=false;">Cancel</button>
                <button class="policyCloseBtn mr-2" [disabled]="!acknowledge" (click)="confirmCancel();">Cancel Policy</button>
            </div>
        </div>
    </p-dialog>
</div>